import { Path, useController } from "react-hook-form";
import { FieldValues } from "react-hook-form/dist/types/fields";
import { Control } from "react-hook-form-mui";
import Rating from "@mui/material/Rating";
import React from "react";

export default function RatingElement<T extends FieldValues>({ control, name }: { control: Control<T>; name: Path<T> }) {
    const { field } = useController({
        name,
        control,
    });

    return (
        <Rating
            {...field}
            onChange={(event, value) => {
                field.onChange(value);
            }}
            size="large"
        />
    );
}
